/*! jswebrtc v1.0 | (c) Derek Chan | MIT license */
/**
 * 初始工具类，现已弃用，请使用 selfJSWebrtc.js
 */

// This sets up the JSWebrtc "Namespace". The object is empty apart from the Now()
// utility function and the automatic CreateVideoElements() after DOMReady.
let JSWebrtc = {

  checkH265Support: function () {
    if (window.RTCRtpSender && RTCRtpSender.getCapabilities) {
      const capabilities = RTCRtpSender.getCapabilities('video')
      if (capabilities && capabilities.codecs) {
        const hasH265 = capabilities.codecs.some(codec => {
          codec.mimeType.toLowerCase().includes('h265') ||
          codec.mimeType.toLowerCase().includes('hevc')
        })
        console.log('H.265支持检测:', hasH265 ? '支持' : '不支持');
        return hasH265;
      }
      // 方法2: 检查video元素支持
      const video = document.createElement('video');
      const canPlayH265 = video.canPlayType('video/mp4; codecs="hvc1"') ||
        video.canPlayType('video/mp4; codecs="hevc"');
      console.log('Video元素H.265支持:', canPlayH265 ? '可能支持' : '不支持');

      return !!canPlayH265;
    }
  },
	// The Player sets up the connections between source, demuxer, decoders,
	// renderer and audio output. It ties everything together, is responsible
	// of scheduling decoding and provides some convenience methods for
	// external users.
	Player : function (url, options) {

      this.options = options || {};
      if (!url.match(/^webrtc?:\/\//)) {
        throw"JSWebrtc just work with webrtc"
      }
      if (!this.options.video) {
        throw"VideoElement is null"
      }
      this.urlParams = this.ParseUrl(url);
      this.pc = null;
      this.autoplay = !!options.autoplay || false;
      this.paused = true;
      let muted = options.muted ? options.muted : false;
      if (this.autoplay && !muted) this.options.video.muted = true;
      this.startLoading()
      let newParam = {
        urlParams:this.urlParams,
        pc:this.pc,
        audioOut:this.audioOut
      }
  ;
    return newParam;
  },

  startLoading:function(){
    let _self = this;
    if (_self.pc) {
      _self.pc.close()
    }
    _self.pc = new RTCPeerConnection(null);
    _self.pc.ontrack = function (event) {
      _self.options.video["srcObject"] = event.streams[0]
    };
    _self.pc.addTransceiver("audio", {direction: "recvonly"});
    _self.pc.addTransceiver("video", {direction: "recvonly"});
    _self.pc.createOffer().then(function (offer) {
      return _self.pc.setLocalDescription(offer).then(function () {
        return offer
      })
    }).then(function (offer) {
      return new Promise(function (resolve, reject) {
        let port = _self.urlParams.port || 1985;
        let api = _self.urlParams.user_query.play || "/rtc/v1/play/";
        if (api.lastIndexOf("/") != api.length - 1) {
          api += "/"
        }
        let url = _self.urlParams.urlSchema+"://" + _self.urlParams.server + ":" + port + api;
        let params = ''
        for (let key in _self.urlParams.user_query) {
          if (key != "api" && key != "play") {
            params += "&" + key + "=" + _self.urlParams.user_query[key]
          }
        }
        if (params) {
          params = params.substring(1);
        }
        url += '?' + params
        let data = {api: url, streamurl: _self.urlParams.url, clientip: null, sdp: offer.sdp};
        _self.HttpPost(url, JSON.stringify(data)).then(function (res) {
          resolve(res.sdp)
        }, function (rej) {
          reject(rej)
        })
      })
    }).then(function (answer) {
      return _self.pc.setRemoteDescription(new RTCSessionDescription({type: "answer", sdp: answer}))
    }).catch(function (reason) {
      throw reason
    });
    if (this.autoplay) {
      this.play()
    }
  },

  play : function (ev) {
    console.log('开始播放，当前编解码器:', this.checkH265Support() ? 'H.265' : 'H.264/VP8');
    if (this.animationId) {
      return
    }
    this.animationId = requestAnimationFrame(this.update.bind(this));
    this.paused = false
  },
  pause : function (ev) {
    if (this.paused) {
      return
    }
    cancelAnimationFrame(this.animationId);
    this.animationId = null;
    this.isPlaying = false;
    this.paused = true;
    this.options.video.pause();
    if (this.options.onPause) {
      this.options.onPause(this)
    }
  },
  stop : function (ev) {
    this.pause()
  },
  destroy : function () {
    this.pause();
    this.pc && this.pc.close() && this.pc.destroy();
    this.audioOut && this.audioOut.destroy()
  },
  update : function () {
    this.animationId = requestAnimationFrame(this.update.bind(this));
    if (this.options.video.readyState < 4) {
      return
    }
    if (!this.isPlaying) {
      this.isPlaying = true;
      this.options.video.play();
      if (this.options.onPlay) {
        this.options.onPlay(this)
      }
    }
  },
	// A Video Element wraps the Player, shows HTML controls to start/pause
	// the video and handles Audio unlocking on iOS. VideoElements can be
	// created directly in HTML using the <div class="jswebrtc"/> tag.
	VideoElement: function (element) {
    let url = element.dataset.url;
    if (!url) {
      throw"VideoElement has no `data-url` attribute"
    }
    let addStyles = function (element, styles) {
      for (let name in styles) {
        element.style[name] = styles[name]
      }
    };
    this.container = element;
    addStyles(this.container, {display: "inline-block", position: "relative", minWidth: "80px", minHeight: "80px"});
    this.video = document.createElement("video");
    this.video.width = 960;
    this.video.height = 540;
    addStyles(this.video, {display: "block", width: "100%"});
    this.container.appendChild(this.video);
    this.playButton = document.createElement("div");
    this.playButton.innerHTML = VideoElement.PLAY_BUTTON;
    addStyles(this.playButton, {
      zIndex: 2,
      position: "absolute",
      top: "0",
      bottom: "0",
      left: "0",
      right: "0",
      maxWidth: "75px",
      maxHeight: "75px",
      margin: "auto",
      opacity: "0.7",
      cursor: "pointer"
    });
    this.container.appendChild(this.playButton);
    let options = {video: this.video};
    for (let option in element.dataset) {
      try {
        options[option] = JSON.parse(element.dataset[option])
      } catch (err) {
        options[option] = element.dataset[option]
      }
    }
    this.player = new this.Player(url, options);
    element.playerInstance = this.player;
    if (options.poster && !options.autoplay) {
      options.decodeFirstFrame = false;
      this.poster = new Image;
      this.poster.src = options.poster;
      this.poster.addEventListener("load", this.posterLoaded);
      addStyles(this.poster, {display: "block", zIndex: 1, position: "absolute", top: 0, left: 0, bottom: 0, right: 0});
      this.container.appendChild(this.poster)
    }
    if (!this.player.options.streaming) {
      this.container.addEventListener("click", this.onClick.bind(this))
    }
    if (options.autoplay) {
      this.playButton.style.display = "none"
    }
    if (this.player.audioOut && !this.player.audioOut.unlocked) {
      let unlockAudioElement = this.container;
      if (options.autoplay) {
        this.unmuteButton = document.createElement("div");
        this.unmuteButton.innerHTML = VideoElement.UNMUTE_BUTTON;
        addStyles(this.unmuteButton, {
          zIndex: 2,
          position: "absolute",
          bottom: "10px",
          right: "20px",
          width: "75px",
          height: "75px",
          margin: "auto",
          opacity: "0.7",
          cursor: "pointer"
        });
        this.container.appendChild(this.unmuteButton);
        unlockAudioElement = this.unmuteButton
      }
      this.unlockAudioBound = this.onUnlockAudio.bind(this, unlockAudioElement);
      unlockAudioElement.addEventListener("touchstart", this.unlockAudioBound, false);
      unlockAudioElement.addEventListener("click", this.unlockAudioBound, true)
    }
  },

	CreateVideoElements: function () {
		let elements = document.querySelectorAll('.jswebrtc');
		for (let i = 0; i < elements.length; i++) {
			new this.VideoElement(elements[i]);
		}
	},

	FillQuery: function (query_string, obj) {
		// pure user query object.
		obj.user_query = {};

		if (query_string.length == 0)
			return;

		// split again for angularjs.
		if (query_string.indexOf("?") >= 0)
			query_string = query_string.split("?")[1];

		let queries = query_string.split("&");
		for (let i = 0; i < queries.length; i++) {
			let query = queries[i].split("=");
			obj[query[0]] = query[1];
			obj.user_query[query[0]] = query[1];
		}

		// alias domain for vhost.
		if (obj.domain)
			obj.vhost = obj.domain;
	},

	ParseUrl: function (rtmp_url) {
		// @see: http://stackoverflow.com/questions/10469575/how-to-use-location-object-to-parse-url-without-redirecting-the-page-in-javascri
		let a = document.createElement("a");
		a.href = rtmp_url.replace("rtmp://", "http://")
			.replace("webrtc://", "http://")
			.replace("rtc://", "http://");

		let vhost = a.hostname;
		let app = a.pathname.substr(1, a.pathname.lastIndexOf("/") - 1);
		let stream = a.pathname.substr(a.pathname.lastIndexOf("/") + 1);

		// parse the vhost in the params of app, that srs supports.
		app = app.replace("...vhost...", "?vhost=");
		if (app.indexOf("?") >= 0) {
			let params = app.substr(app.indexOf("?"));
			app = app.substr(0, app.indexOf("?"));

			if (params.indexOf("vhost=") > 0) {
				vhost = params.substr(params.indexOf("vhost=") + "vhost=".length);
				if (vhost.indexOf("&") > 0) {
					vhost = vhost.substr(0, vhost.indexOf("&"));
				}
			}
		}

		// when vhost equals to server, and server is ip,
		// the vhost is __defaultVhost__
		if (a.hostname == vhost) {
			let re = /^(\d+)\.(\d+)\.(\d+)\.(\d+)$/;
			if (re.test(a.hostname))
				vhost = "__defaultVhost__";
		}

		// parse the schema
		let schema = "rtmp";
		if (rtmp_url.indexOf("://") > 0)
			schema = rtmp_url.substr(0, rtmp_url.indexOf("://"));

		let port = a.port;
		if (!port) {
			if (schema === 'http') {
				port = 80;
			} else if (schema === 'https') {
				port = 443;
			} else if (schema === 'rtmp') {
				port = 1935;
			} else if (schema === 'webrtc' || schema === 'rtc') {
				port = 1985;
			}
		}
		let httpProtocol = window.location.protocol
    if (httpProtocol.indexOf('https') > -1) {
      httpProtocol = "https"
    }else{
      httpProtocol = "http"
    }

		let ret = {
			url: rtmp_url,
			schema: schema,
      urlSchema: httpProtocol,
			server: a.hostname, port: port,
			vhost: vhost, app: app, stream: stream
		};

		this.FillQuery(a.search, ret);

		return ret;
	},

	HttpPost: function (url, data) {
		return new Promise(function (resolve, reject) {
			let xhr = new XMLHttpRequest();
			xhr.onreadystatechange = function () {
				if (xhr.readyState === 4 && (xhr.status >= 200 && xhr.status < 300)) {
					let respone = JSON.parse(xhr.responseText);
					xhr.onreadystatechange = new Function;
					xhr = null;
					resolve(respone);
				}
			};

			xhr.open("POST", url, true);

			// note: In Internet Explorer, the timeout property may be set only after calling the open()
			// method and before calling the send() method.
			xhr.timeout = 5000;// 5 seconds for timeout
			xhr.responseType = "text";
			xhr.setRequestHeader("Content-Type", "application/json");
			xhr.send(data);
		})

	},

};

// Automatically create players for all found <div class="jswebrtc"/> elements.
if (document.readyState === 'complete') {
	this.CreateVideoElements();
}
else {
	document.addEventListener('DOMContentLoaded', this.CreateVideoElements);
}
export default JSWebrtc



// WEBPACK FOOTER //
// ./src/assets/jswebrtc.js